import {
  createBlock,
  mergeBlock,
  NodeUtils,
  t,
} from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  Element,
  ElementDefinition,
  StandardTable2TrElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components/BasicBlock";
import { BlockRenderer } from "@easy-email-pro-core/components";
import { pick } from "lodash";

const defaultData: ElementDefinition<StandardTable2TrElement>["defaultData"] = {
  attributes: {},
  data: {},
};

export const StandardTable2Tr = createBlock<StandardTable2TrElement>({
  get name() {
    return t("Table Tr");
  },
  void: false,
  defaultData,
  type: StandardType.STANDARD_TABLE2_TR,
  create: (payload) => {
    const defaultData: StandardTable2TrElement = {
      type: StandardType.STANDARD_TABLE2_TR,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TABLE2_TR,
  render(params) {
    const { node } = params;

    const styles = [] as string[];
    const attributes = node.attributes;
    if (attributes["background-color"]) {
      styles.push(`background-color:  ${attributes["background-color"]}`);
    }

    return (
      <BasicBlock
        params={{
          ...params,
          node: {
            ...node,
            attributes: {
              style: styles.join(";"),
            } as any,
          },
        }}
        tag={"tr"}
        children={node.children.map((item, index) => {
          if (NodeUtils.isTextNode(item))
            return <React.Fragment key={index}></React.Fragment>;

          return (
            <BlockRenderer
              key={index}
              node={
                {
                  ...item,
                  attributes: {
                    ...pick(node.attributes, [
                      "border-color",
                      "border-style",
                      "border-width",
                      "border-enabled",
                      "text-align",
                    ]),
                    ...item.attributes,
                  },
                } as Element
              }
            />
          );
        })}
      />
    );
  },
});
